import React, {  useMemo } from "react";
import RipianiHeader from "./Header";
import RipianiTable from "./Table";

const EMPTY_RIPIANI = [];

const RipianiSection = ({ ripiani = [], setRipiani, edit= false }) => {

  const ripianiRef = ripiani ?? EMPTY_RIPIANI;

  const localRipiani = useMemo(
    () =>
      [...ripianiRef]
        .sort((a, b) => {
          if(a.id && b.id) {
            return a.id - b.id;
          } else if(a.id && !b.id) {
            return 1;
          } else if(!a.id && b.id) {
            return -1;
          } else {
            return (b.nome || "").localeCompare(a.nome || "");
          }
        })
        .map((ripiano, index) => ({
          id: ripiano.id ?? index,
          nome: ripiano.nome ?? '',
        })),
    [JSON.stringify(ripiani)] // stable: only changes when content changes
  );

  const handleDeleteRipiano = (ripiano) => {
    let newRipiani = localRipiani.filter((item) => item.id !== ripiano.id);
    setRipiani(newRipiani);
  };

  const handleUpdateRipiano = (ripiano) => {
    const newRipiani = localRipiani.map((item) => {
      if (item.id === ripiano.id) {
        return {id: ripiano.id, nome: ripiano.nome};
      } else {
        return item;
      }
    });
    setRipiani(newRipiani);
  };

  const handleAddRipiano = () => {
    const nextId =
      ripianiRef.length === 0
        ? 0
        : Math.max(0, ...ripianiRef.map((r) => (r.id != null && Number.isFinite(r.id) ? r.id : 0))) + 1;
    const newRipiano = { nome: '', id: nextId };
    setRipiani([...ripianiRef, newRipiano]);
  };
  
  return (
    <>
      <div className="ripiani-container">
        <RipianiHeader
          edit={edit}
          handleAddRipiano={handleAddRipiano}
          ripianiCount={localRipiani.length}
        />
        <RipianiTable
          ripiani={localRipiani}
          handleDeleteRipiano={handleDeleteRipiano}
          handleUpdateRipiano={handleUpdateRipiano}
          edit={edit}
        />
      </div>
    </>
  );
};

export default RipianiSection;
